// extracted by css-extract-rspack-plugin
export default {"changePasswordLink":"fAQ15u_cT0IBpqFs","hiddenInput":"Ktlp8Z1_m8ohhtjO"};